<template>
  <div :class="{ 'disabled': isDisabled }">
    <label :for="label" :class="classes" class="display-flex align-center">
      <input :id="label" type="checkbox" :name="label" :checked="checked" :disabled="isDisabled" @change="emit">
      <span class="ml1">{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'bh-checkbox',
  props: {
    value: {
      type: String | Object | Boolean,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDisabled: {
      get() {
        return this.disabled
      }
    }
  },
  methods: {
    emit(e) {
      this.$emit('output', { value: this.value, checked: e?.target?.checked })
    }
  }
}
</script>
